import { render } from "./ConfirmationMessage.vue?vue&type=template&id=4576595f&ts=true"
import script from "./ConfirmationMessage.vue?vue&type=script&lang=ts"
export * from "./ConfirmationMessage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__